import { forwardRef, ReactElement } from 'react'
import { FlexProps } from './props'
import { StyledFlex } from './styles'

const Flex = forwardRef<HTMLDivElement, FlexProps>(
    (props, ref): ReactElement => <StyledFlex {...props} ref={ref} />
)

Flex.displayName = 'Flex'

export default Flex

export { StyledFlex }
